import { useState, useCallback } from "react";
/**
 * Hook for Stripe checkout and customer portal operations
 */
export function useCheckout(options) {
    const { apiConfig } = options;
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const initiateCheckout = useCallback(async (checkoutOptions) => {
        try {
            setIsLoading(true);
            setError(null);
            const accessToken = await apiConfig.getAccessToken();
            const response = await fetch(`${apiConfig.baseUrl}/billing/create-checkout`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    priceId: checkoutOptions.priceId,
                    mode: checkoutOptions.mode,
                    successUrl: checkoutOptions.successUrl,
                    cancelUrl: checkoutOptions.cancelUrl,
                }),
            });
            if (!response.ok) {
                throw new Error(`Failed to create checkout session: ${response.status}`);
            }
            const data = (await response.json());
            return data.clientSecret;
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            setError(error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    }, [apiConfig]);
    const initiatePortal = useCallback(async (portalOptions) => {
        try {
            setIsLoading(true);
            setError(null);
            const accessToken = await apiConfig.getAccessToken();
            const response = await fetch(`${apiConfig.baseUrl}/billing/create-portal`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    returnUrl: portalOptions.returnUrl,
                }),
            });
            if (!response.ok) {
                throw new Error(`Failed to create portal session: ${response.status}`);
            }
            const data = (await response.json());
            return data.url;
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            setError(error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    }, [apiConfig]);
    return {
        initiateCheckout,
        initiatePortal,
        isLoading,
        error,
    };
}
//# sourceMappingURL=use-checkout.js.map